import React from 'react'
import { dracula } from 'react-syntax-highlighter/dist/cjs/styles/prism'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import ReactMarkdownWithHtml from 'react-markdown'
import rehypeRaw from 'rehype-raw'

import { ContentWrapper } from './MDContent.style'

interface IProps {
  content: string
}

const MDContent = (props: IProps) => {
  const { content } = props
  return (
    <div className='container mx-auto py-7 w-full format format-sm sm:format-base lg:format-lg format-blue dark:format-invert'>
      <ContentWrapper>
        <ReactMarkdownWithHtml
          components={{
            code({ className, children, ...props }) {
              const match = /language-(\w+)/.exec(className || '')
              return match ? (
                <SyntaxHighlighter
                  language={match[1]}
                  PreTag='div'
                  {...props}
                  style={dracula}
                >
                  {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
              ) : (
                <code className={className} {...props}>
                  {children}
                </code>
              )
            },
          }}
          rehypePlugins={[rehypeRaw]}
        >
          {content}
        </ReactMarkdownWithHtml>
      </ContentWrapper>
    </div>
  )
}

export default MDContent
